import React, { useEffect, useRef } from 'react';
import { ecosystemPartners } from '../mock';

const EcosystemClean = () => {
  const ecosystemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = ecosystemRef.current?.querySelectorAll('.fade-in');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="ecosystem-section-clean" ref={ecosystemRef}>
      <div className="ecosystem-container-clean">
        <h2 className="section-title-clean fade-in">The Ecosystem Engine</h2>
        <p className="section-subtitle-clean fade-in">Collaborated and Marketed with Leading Networks and Enterprises</p>

        <div className="ecosystem-grid fade-in">
          {ecosystemPartners.map((partner, index) => (
            <div
              key={index}
              className="ecosystem-logo"
              style={{ '--brand-color': partner.color }}
            >
              <img 
                src={partner.logo} 
                alt={partner.name}
                className="logo-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EcosystemClean;